module.exports = __webpack_public_path__ + "static/assets/f82adafc7c09b6446509ff35296e7675.jpg";